import script from "./NotificationFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationFeed.vue?vue&type=script&setup=true&lang=js"

import "./NotificationFeed.vue?vue&type=style&index=0&id=a7fcf34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7fcf34c"]])

export default __exports__